import React from 'react';
import OnboardingTemplate from '../OnboardingTemplate';
import { FormContent } from './Login.styles';
import Button from '../Button';
import Form, { useForm } from '../Form';
import Field from '../Field';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../context/authContext';
import Layout from '../Layout';
import { Link } from 'react-router-dom';
import { Mail, KeyRound } from 'lucide-react';
import FormFieldIcon from '../FormFieldIcon';

function Login() {
  const [form] = useForm();

  const { onLogin, loading_user } = useContextHook(AuthContext, v => ({
    onLogin: v.onLogin,
    loading_user: v.loading_user,
    loading_user_google: v.loading_user_google,
  }));

  const handleSubmit = e => {
    const payload = {
      email: e?.email,
      password: e?.password,
    };
    onLogin(payload);
  };

  return (
    <>
      <Layout showTemplate={false}>
        <OnboardingTemplate>
          <FormContent>
            <div className="text-content">
              <div className="text-wrapper">
                <div className="heading-text">
                  <h1>Sign In</h1>
                </div>
                <div className="formWrapper">
                  <Form form={form} onSubmit={handleSubmit}>
                    <Form.Item
                      type="email"
                      rounded
                      lg
                      name="email"
                      placeholder="Enter your email address"
                      rules={[
                        {
                          required: true,
                          message: 'Email is Required',
                        },
                      ]}
                      prefix={<FormFieldIcon icon={Mail} size={20} />}>
                      <Field />
                    </Form.Item>
                    <Form.Item
                      type="password"
                      rounded
                      name="password"
                      placeholder="Enter password"
                      prefix={<FormFieldIcon icon={KeyRound} size={20} />}
                      rules={[
                        {
                          required: true,
                          message: 'Password is Required',
                        },
                      ]}>
                      <Field />
                    </Form.Item>

                    <div className="btn-holder">
                      <Button loader={loading_user}>Continue</Button>
                    </div>
                  </Form>
                </div>
              </div>
              <div className="footer">
                Don't have an account? <Link to="/sign-up">Sign Up</Link>{' '}
              </div>
            </div>
          </FormContent>
        </OnboardingTemplate>
      </Layout>
    </>
  );
}

export default Login;
